import React, { useEffect, useState, useId } from 'react';

interface Props {
  checked: boolean;
  onChange: (value: boolean) => void;
}

const AppSwitch = ({ checked, onChange }: Props) => {
  const [isChecked, setIsChecked] = useState(checked);
  const switchId = useId();

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange(newValue);
  };

  return (
    <div className="relative inline-block w-12 align-middle select-none transition duration-200 ease-in">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="hidden"
        id={`switch-${switchId}`}
        role="switch"
        aria-checked={isChecked}
      />
      <label 
        data-testid="label-switch" 
        htmlFor={`switch-${switchId}`} 
        className="cursor-pointer block"
      >
        {/* Track (fondo del switch) */}
        <span 
          className={`block h-6 w-12 rounded-full transition-colors duration-200 ease-in-out ${
            isChecked ? 'bg-[#568C13]' : 'bg-gray-300'
          }`}
        ></span>
        
        {/* Thumb (círculo blanco) */}
        <span 
          className={`absolute top-1 left-0.5 w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-200 ease-in-out ${
            isChecked ? 'translate-x-6' : 'translate-x-0'
          }`}
        ></span>
      </label>
    </div>
  );
};

export default AppSwitch;